import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';

import { drawerInitialState, layoutInitialState } from './tileDrawerSlice';

const selectTileState = (state?: RootState) => state?.tileDrawer || drawerInitialState;
const selectLayoutState = (state?: RootState) => state?.layout || layoutInitialState;

export const selectTileDrawer = createSelector([selectTileState], tileDrawer => tileDrawer);
export const selectLayout = createSelector([selectLayoutState], layout => layout);
